<template>
  <div class="card">
    <div class="p-6">
      <div class="text-2xl font-semibold flex items-center gap-3 mb-6">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-6 h-6 text-psychology-secondary">
          <path d="M5 12h14"></path>
          <path d="m12 5 7 7-7 7"></path>
        </svg>
        测评流程
      </div>

      <div class="space-y-4">
        <!-- 步骤1 -->
        <div class="flex items-start gap-4 p-4 bg-psychology-calm rounded-lg border border-psychology-primary/10">
          <div class="flex-shrink-0 w-8 h-8 bg-psychology-primary text-white rounded-full flex items-center justify-center text-sm font-semibold">
            1
          </div>
          <div class="flex-1">
            <div class="flex items-center gap-2 mb-1">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5 text-psychology-primary">
                <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
              </svg>
              <h4 class="font-semibold text-gray-900">知情同意</h4>
            </div>
            <p class="text-sm text-gray-600">阅读并同意参与测评的条款</p>
          </div>
        </div>

        <!-- 步骤2 -->
        <div class="flex items-start gap-4 p-4 bg-psychology-calm rounded-lg border border-psychology-primary/10">
          <div class="flex-shrink-0 w-8 h-8 bg-psychology-primary text-white rounded-full flex items-center justify-center text-sm font-semibold">
            2
          </div>
          <div class="flex-1">
            <div class="flex items-center gap-2 mb-1">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5 text-psychology-primary">
                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                <circle cx="9" cy="7" r="4"></circle>
                <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
                <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
              </svg>
              <h4 class="font-semibold text-gray-900">基本信息</h4>
            </div>
            <p class="text-sm text-gray-600">填写年龄、性别、星座、恋爱状态等信息</p>
          </div>
        </div>

        <!-- 步骤3 -->
        <div class="flex items-start gap-4 p-4 bg-psychology-calm rounded-lg border border-psychology-primary/10">
          <div class="flex-shrink-0 w-8 h-8 bg-psychology-primary text-white rounded-full flex items-center justify-center text-sm font-semibold">
            3
          </div>
          <div class="flex-1">
            <div class="flex items-center gap-2 mb-1">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5 text-psychology-primary">
                <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"></path>
                <path d="M14 2v4a2 2 0 0 0 2 2h4"></path>
                <path d="M10 9H8"></path>
                <path d="M16 13H8"></path>
                <path d="M16 17H8"></path>
              </svg>
              <h4 class="font-semibold text-gray-900">问卷作答</h4>
            </div>
            <p class="text-sm text-gray-600">根据实际情况诚实回答40道题目</p>
          </div>
        </div>

        <!-- 步骤4 -->
        <div class="flex items-start gap-4 p-4 bg-psychology-calm rounded-lg border border-psychology-primary/10">
          <div class="flex-shrink-0 w-8 h-8 bg-psychology-primary text-white rounded-full flex items-center justify-center text-sm font-semibold">
            4
          </div>
          <div class="flex-1">
            <div class="flex items-center gap-2 mb-1">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5 text-psychology-primary">
                <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"></path>
              </svg>
              <h4 class="font-semibold text-gray-900">查看结果</h4>
            </div>
            <p class="text-sm text-gray-600">获得详细的RPI指数和四维度分析</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProcessSteps'
}
</script>

